export default [
    {
        key: "forwardhead",
        name: "Protrusión de la cabeza",
        definition: {
            name: "Definición",
            list: ["La protrusión de la cabeza se refiere a que cuando el cuerpo humano está en la posición natural de pie o sentado, la cabeza está en una posición anormalmente inclinada hacia adelante con respecto al tronco. Es común en estudiantes y personas en la oficina que se sientan durante mucho tiempo."]
        },
        triggerreason: {
            name: "Las causas",
            list: [
                "1、Trabajar inclinado durante mucho tiempo. Cuando se trabaja frente a la computadora durante mucho tiempo, la cabeza se inclina hacia adelante habitualmente.",
                "2、Acostumbrarse a bajar la cabeza para mirar el teléfono móvil. Mirar el teléfono móvil con la cabeza baja, es decir, la llamada ‘tribu de los que bajan la cabeza’, también es una de las principales causas que inducen la protusión de la cabeza.",
            ]
        },
        danger: {
            name: "Riesgos",
            list: [
                "1. Mareos y dolor de cabeza: La protusión de la cabeza puede afectar la circulación sanguínea en la cabeza. Debido a un mal flujo sanguíneo, hay falta de oxígeno en la cabeza, lo que provoca mareos y dolor de cabeza.",
                "2. Cervicalgia: Debido a la posición anormal de la cabeza, se producen anormalidades en los tejidos blandos y huesos del cuello, aumentando el riesgo de enfermedades cervicales.",
                "3. Enfermedades cardiovasculares y cerebrovasculares: La posición anormal de la cabeza puede afectar la circulación sanguínea en la cabeza y perjudicar la salud cardiovascular y cerebrovascular.",
            ],
        }
    },
    {
        key: "lateralhead",
        name: "Inclinación lateral de la cabeza",
        definition: {
            name: "Definición",
            list: ["Inclinación lateral de la cabeza se refiere a la postura anormal en la que la cabeza se inclina excesivamente hacia un lado cuando el cuerpo humano está en la posición natural de pie o sentado. La principal causa es el desequilibrio de la fuerza muscular del cuello y los hombros en ambos lados, generalmente causado por posturas incorrectas habituales."]
        },
        triggerreason: {
            name: "Causas",
            list: [
                "1. Usar habitualmente los músculos del cuello y el hombro de un lado: Cuando se está sentado o acostado, el cuello a menudo se inclina solo hacia un lado, lo que causa un desequilibrio en la fuerza muscular del cuello y los hombros de ambos lados.",
            ]
        },
        danger: {
            name: "Riesgos",
            list: [
                "1. Desgaste crónico de los músculos y ligamentos: La inclinación lateral de la cabeza durante mucho tiempo puede provocar fácilmente un desgaste crónico de los ligamentos posteriores del cuello y de los ligamentos y músculos.",
                "2. Cervicalgia: Debido a la posición anormal de la cabeza, se producen anormalidades en los tejidos blandos y huesos del cuello, aumentando el riesgo de enfermedades cervicales.",
            ],
        }
    },
    {
        key: "unevenshoulder",
        name: "hombros desiguales",
        definition: {
            name: "Definición",
            list: ["hombros desiguales se refiere a la situación en la que los hombros de ambos lados tienen alturas verticales diferentes cuando el cuerpo humano está en un estado de relajación natural. Generalmente, los hombros desiguales están acompañados de anormalidades en la postura de la columna vertebral."]
        },
        triggerreason: {
            name: "Las causas",
            list: [
                "1. Fuerza excesiva en un lado: por ejemplo, llevar una mochila o cargar objetos pesados en un lado durante mucho tiempo.",
                "2. Postura incorrecta durante mucho tiempo: Causada por malos hábitos como cruzar las piernas y sentarse durante mucho tiempo, o inclinarse sobre la mesa al trabajar inclinado.",
            ]
        },
        danger: {
            name: "Riesgos",
            list: [
                "1. Dolor de espalda: (hombros desiguales) pueden causar un desplazamiento de la pelvis, haciendo que la fuerza muscular de ambos lados de la cintura esté desequilibrada y causando dolor de espalda.",
                "2. Osteofito: Los hombros desiguales hacen que la fuerza en la columna cervical sea anormal y, finalmente, pueden provocar la degeneración de la región de la coluna cervical y facilitar la formación de osteofitos.",
            ],
        }
    },
    {
        key: "roundedshoulder",
        name: "hombros redondeados",
        definition: {
            name: "Definición",
            list: ["Los hombros redondos se refieren al estado en que los hombros aparecen curvados hacia adelante y hacia adentro cuando se observa lateralmente. A menudo acompañado de joroba. Común en estudiantes y personas que trabajan en oficinas."],
        },
        triggerreason: {
            name: "Las causas",
            list: [
                "1. Postura habitual mala: como encorvarse y tener joroba, acostarse de lado de forma irregular etc.",
                "2. Desequilibrio muscular en el pecho y la espalda: Los músculos pectorales son relativamente débiles en comparación con los músculos de la espalda.",
            ]
        },
        danger: {
            name: "Riesgos",
            list: [
                "1. Mayor carga en el corazón: Los hombros demasiado redondeados harán que el diafragma esté tenso, causando la compresión de la aorta y la vena cava y aumentando la carga de trabajo del corazón.",
                "2. Nervios comprimidos: La tensión muscular alrededor de los hombros y el cuello puede, en casos graves, comprimir los nervios cervicales y causar dolor de cabeza y entumecimiento en el brazo.",
            ],
        }
    },
    {
        name: "escoliosis vertebral",
        key: "scoliosis",
        definition: {
            name: "Definición",
            list: ["Se presentan anormalidades en la posición de la columna vertebral. A través de exámenes de imagen, se pueden detectar estados no rectos de la coluna vertebral, como escoliosis vertebral. Las anormalidades se pueden dividir en congénitas y adquiridas. Las anormalidades adquiridas están relacionadas con errores habituales de postura."],
        },
        triggerreason: {
            name: "Las causas",
            list: [
                "1. Excesiva fuerza unilateral: por ejemplo, llevar una mochila o cargar objetos pesados unilateralmente durante mucho tiempo.",
                "2. Postura incorrecta durante mucho tiempo: Causada por malos hábitos como cruzar las piernas y estar sentado por mucho tiempo, o inclinarse sobre la mesa al trabajar inclinado.",
                "3. Causas congénitas: Escoliosis vertebral causada por factores congénitos.",
            ]
        },
        danger: {
            name: "Riesgos",
            list: [
                "1. Herniación de disco lumbar.",
                "2. Dolor de espalda: Puede causar un desplazamiento de la pelvis, haciendo que la fuerza muscular de ambos lados de la cintura esté desequilibrada y provocando dolor de espalda.",
                "3. Piernas de diferente longitud.",
            ],
        }
    },
    {
        name: "inclinación lateral de la pelvis",
        key: "unevenhip",
        definition: {
            name: "Definición",
            list: ["La inclinación lateral de la pelvis se refiere al estado en que la altura de las caderas de ambos lados es bastante diferente, presentando un estado de inclinación de la pelvis. A menudo se acompaña de anormalidades en la posición de la columna vertebral y hombros desiguales."],
        },
        triggerreason: {
            name: "Las causas",
            list: [
                "1. Postura incorrecta durante mucho tiempo: Causada por malos hábitos como cruzar las piernas y estar sentado por mucho tiempo, o inclinarse sobre la mesa al trabajar inclinado.",
                "2. Piernas de diferente longitud congénitas: Inclinación lateral de la pelvis causada por piernas de diferente longitud congénitas.",
                "3. Desequilibrio postural de las extremidades inferiores de ambos lados: por ejemplo, un pie tiene pie plano mientras que el otro no, o el grado es diferente; ambos lados tienen hiper-extensión de la rodilla, pero el grado es diferente.",
            ]
        },
        danger: {
            name: "Riesgos",
            list: [
                "1. Herniación de disco lumbar.",
                "2. Dolor crónico: La inclinación lateral de la pelvis puede provocar dolor en las piernas y la cintura, así como en el cuello y los hombros.",
                "3. Piernas de diferente longitud.",
            ],
        }
    },
    {
        name: "piernas en forma de O",
        key: "oleg",
        definition: {
            name: "Definición",
            list: ["Cuando una persona está de pie con postura normal y los pies están juntos, los tobillos internos pueden estar pegados pero los interiores de las rodillas no pueden estar pegados e incluso puede haber una gran brecha. Entre las piernas aparece una forma de \"O\". Este tipo de forma de pierna está relacionada con los hábitos de postura diaria. La aparición de piernas en forma de \"O\" en niños también puede estar relacionada con el raquitismo."],
        },
        triggerreason: {
            name: "Las causas",
            list: [
                "1. Malos hábitos posturales como: inclinación posterior de la pelvis y tendencia a la pronación del pie.",
                "2. Desequilibrio de fuerza muscular, como: músculos rotadores externos de la cadera demasiado tensos.",
            ]
        },
        danger: {
            name: "Riesgos",
            list: [
                "1. Lesión del menisco medial: Las piernas en forma de O provocan cambios en la línea de fuerza de las extremidades inferiores. El espacio medial de la rodilla soporta una presión mayor que la carga normal. Puede causar lesión del menisco medial de la rodilla.",
                "2. Artritis: Los casos graves (piernas en forma de O) pueden eventualmente desarrollarse en osteoartritis de rodilla y degeneración articular en el espacio articular lateral. En casos graves, puede ser necesario realizar una cirugía de reemplazo articular artificial.",
            ],
        }
    },
    {
        name: "piernas en forma de X",
        key: "xleg",
        definition: {
            name: "Definición",
            list: "Cuando una persona está de pie en postura normal y las piernas están juntas, las rodillas internas pueden estar juntas, pero la parte interna de los tobillos no puede estar juntas e incluso puede haber una gran brecha. La forma entre las piernas es como la letra \"X\". Este tipo de forma de las piernas está relacionado con los hábitos posturales diarios y el desequilibrio muscular.",
        },
        triggerreason: {
            name: "Las causas",
            list: [
                "1. Malas posturas habituales como: anteversión pélvica, tendencia a la eversión del pie.",
                "2. Desequilibrio muscular, como: músculos de rotación interna de la cadera demasiado tensos.",
            ]
        },
        danger: {
            name: "Riesgos",
            list: [
                "1. Lesión del menisco lateral: Las piernas en forma de X provocan cambios en la línea de fuerza de las extremidades inferiores. El espacio lateral de la rodilla soporta una presión mayor que la carga normal. Puede causar lesión del menisco lateral de la rodilla.",
                "2. Artritis: Los casos graves (piernas en forma de X) pueden eventualmente desarrollarse en osteoartritis de rodilla y degeneración articular en el espacio articular lateral. En casos graves, puede ser necesario realizar una cirugía de reemplazo articular artificial.",
            ],
        }
    },
    {
        name: "hiperextensión de la rodilla",
        key: "kneehyperextension",
        definition: {
            name: "Definición",
            list: ["Hiperextensión de la rodilla, también conocida como 'arco inverso de la rodilla'. Desde el lado del cuerpo humano, se puede ver que la pierna se curva hacia atrás, la rodilla se hunde hacia adentro y la pantorrilla se extiende excesivamente hacia adelante en comparación con el muslo. Este tipo de postura es común en bailarinas y personas con debilidad muscular en el muslo."],
        },
        triggerreason: {
            name: "Las causas",
            list: [
                "1. Postura incorrecta de aplicación de fuerza: Al estar de pie, el peso principal cae en la parte delantera del pie.",
                "2. Tensión en la fascia plantar: Puede ser causada por el uso prolongado de zapatos de tacón alto.",
                "3. Debilidad muscular alrededor de la rodilla. Insuficiencia de fuerza muscular en la parte anterior y posterior del muslo.",
            ]
        },
        danger: {
            name: "Riesgos",
            list: [
                "1. Deformidad de la rodilla: La hiperextensión del rodilla a largo plazo puede provocar un aumento significativo en la incidencia de degeneración articular y causar un desgaste excesivo de la rodilla, lo que resulta en una deformidad articular.",
                "2. Daño al equilibrio general: Hay una gran conexión posicional y funcional entre las tres articulaciones de cadera, rodilla y tobillo. El cambio en la posición de la rodilla afectará la posición del tobillo debajo y la posición de la cadera y la pelvis arriba, dañando gradualmente el equilibrio general del cuerpo. A largo plazo, esto puede causar varios tipos de dolor.",
            ],
        }
    },
]